import { render } from "./BigCatContest.vue?vue&type=template&id=7ce42eb9&scoped=true"
import script from "./BigCatContest.vue?vue&type=script&lang=js"
export * from "./BigCatContest.vue?vue&type=script&lang=js"

import "./BigCatContest.vue?vue&type=style&index=0&id=7ce42eb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce42eb9"]])

export default __exports__